import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-af5d1eaa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "info-container"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dept" }, "部门列表", -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "deptlist" }, "当前部门下无部门", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "outellipsis" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "deptname" }
const _hoisted_10 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dept" }, "人员列表", -1))
const _hoisted_12 = { key: 2 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "deptlist" }, "当前部门下无人员", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 3,
  class: "body"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_ctx.deptInfo)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        (_ctx.deptInfo.dept.length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.deptInfo.dept, (li, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: "deptstyle",
                style: {"display":"flex","width":"95%","justify-content":"space-between"},
                onClick: ($event: any) => (_ctx.getreqdata(li.deptId))
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("img", {
                    src: require('@/assets/projectinfo-images/sheji.png'),
                    style: {"vertical-align":"middle"}
                  }, null, 8, _hoisted_8),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(li.name), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_van_icon, { name: "arrow" })
                ])
              ], 8, _hoisted_6))
            }), 128)),
        _hoisted_11,
        (_ctx.deptInfo.user.length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
          : (_openBlock(), _createElementBlock("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deptInfo.user, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  onClick: ($event: any) => (_ctx.workerInfo(item))
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("img", {
                      src: item.photoUrl
                    }, null, 8, _hoisted_17),
                    _createElementVNode("span", null, _toDisplayString(item.name), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_van_icon, { name: "arrow" })
                  ])
                ], 8, _hoisted_16))
              }), 128))
            ]))
      ]))
    : _createCommentVNode("", true)
}